import { useQuery } from 'react-query';
import { ibsRequest } from '../IBSRequest';

export function useGetIBSLookups() {
  return useQuery(
    ['IBSRequestLookups'],
    async () => {
      const { data: authData } = await ibsRequest.getAccessToken();
      const { data } = await ibsRequest.getIBSLookups(authData.access_token);
      return data;
    },
    {
      refetchOnMount: false,
      staleTime: 100000,
      cacheTime: 100000,
      refetchOnWindowFocus: false,
      retry: false,
    }
  );
}
